import React, { Component, type ComponentType } from 'react';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import Redirect from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/redirect/index.tsx';
import type { PublicArticleSearchResultProps } from '../article-search-result/index.tsx';
import type { SearchKnowledgePublicProps } from '../search-knowledge/index.tsx';
import SearchKnowledgeInlineStateless from './search-knowledge-inline-stateless/view.tsx';

type SearchKnowledgeInlineState = {
	value: string;
	isOpen: boolean;
	transitionToSearchPage: boolean;
};

export type SearchKnowledgeInlineOwnProps = {
	searchScreenPath: string;
	SearchKnowledge: ComponentType<SearchKnowledgePublicProps>;
	SearchResultComponent: ComponentType<PublicArticleSearchResultProps>;
	placeholder: string;
};

export type SearchKnowledgeInlineProps = SearchKnowledgeInlineOwnProps & {
	projectId: number;
	activationId?: string;
};

// eslint-disable-next-line jira/react/no-class-components
export default class SearchKnowledgeInline extends Component<
	SearchKnowledgeInlineProps,
	SearchKnowledgeInlineState
> {
	static defaultProps = {
		searchScreenPath: '',
	};

	state = {
		value: '',
		isOpen: false,
		transitionToSearchPage: false,
	};

	onChange = (value: string) =>
		this.setState({
			value,
		});

	onOpen = () =>
		this.setState({
			isOpen: true,
		});

	onClose = () =>
		this.setState({
			isOpen: false,
		});

	onSubmit = () =>
		this.setState({
			transitionToSearchPage: true,
		});

	render() {
		const { transitionToSearchPage, ...state } = this.state;
		const {
			searchScreenPath,
			projectId,
			SearchKnowledge,
			SearchResultComponent,
			placeholder,
			activationId,
		} = this.props;

		const searchScreenRedirectUrl = searchScreenPath
			? `${searchScreenPath}?q=${state.value}`
			: undefined;

		return (
			<>
				{transitionToSearchPage && searchScreenRedirectUrl && (
					<Redirect to={searchScreenRedirectUrl} push />
				)}

				{state.isOpen && <ViewTracker />}

				<SearchKnowledgeInlineStateless
					{...state}
					projectId={projectId}
					onChange={this.onChange}
					onFieldSearchFocus={this.onOpen}
					onClose={this.onClose}
					onSubmit={this.onSubmit}
					// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
					searchScreenRedirectUrl={searchScreenRedirectUrl}
					SearchResultComponent={SearchResultComponent}
					SearchKnowledge={SearchKnowledge}
					placeholder={placeholder}
					activationId={activationId}
				/>
			</>
		);
	}
}
